import { useParams, Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { articles } from '@/mocks/jinman';

export default function ArticleDetail() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <div className="flex flex-col items-center justify-center py-20">
        <h1 className="font-heading text-2xl text-foreground-950 mb-4">文章未找到</h1>
        <Link to="/articles" className="text-primary-500 hover:text-primary-600 text-sm">
          返回文章列表
        </Link>
      </div>
    );
  }

  return (
    <>
      <SchemaOrg
        type="Article"
        data={{
          headline: article.title,
          description: article.excerpt,
          datePublished: article.date,
        }}
      />
      <SchemaOrg type="WebPage" data={{ name: `jinman - ${article.title}`, description: article.excerpt }} />
      <Breadcrumb
        items={[
          { label: '首页', href: '/' },
          { label: '文章资讯', href: '/articles' },
          { label: article.title },
        ]}
      />

      <article className="bg-background-50 py-10 md:py-14">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          {/* Header */}
          <header className="mb-8 text-center">
            <div className="flex items-center justify-center gap-3 mb-4">
              <span className="text-xs bg-accent-100 text-accent-700 px-2.5 py-0.5 rounded-full">
                {article.category}
              </span>
              <span className="text-xs text-foreground-500">{article.date}</span>
              <span className="text-xs text-foreground-500">{article.readTime} 阅读</span>
            </div>
            <h1 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-4 leading-snug">
              {article.title}
            </h1>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">{article.excerpt}</p>
          </header>

          {/* Featured Image */}
          <div className="h-64 md:h-80 rounded-lg overflow-hidden mb-8">
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Content */}
          <div
            className="prose-custom text-sm text-foreground-800 leading-relaxed"
            dangerouslySetInnerHTML={{ __html: article.content }}
          />

          {/* Back link */}
          <div className="mt-12 pt-8 border-t border-background-200">
            <Link
              to="/articles"
              className="inline-flex items-center gap-2 text-sm text-primary-500 hover:text-primary-600 transition-colors"
            >
              <i className="ri-arrow-left-line"></i>
              返回文章列表
            </Link>
          </div>
        </div>
      </article>

      <style>{`
        .prose-custom h2 {
          font-family: var(--font-heading);
          font-size: 1.25rem;
          color: oklch(var(--foreground-900));
          margin-top: 2rem;
          margin-bottom: 0.75rem;
          font-weight: 600;
        }
        .prose-custom p {
          margin-bottom: 1rem;
          line-height: 1.8;
        }
        .prose-custom h2:first-child {
          margin-top: 0;
        }
      `}</style>
    </>
  );
}